var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{attrs:{"id":"xiami"}},[_c('iframe',{attrs:{"title":"Codster Chat","src":"https://xami.codster.io/?application_id=72cd0565-a4ee-457e-b90f-5d2dd4f17d40","width":"100%","height":"600vh"}})])
}]

export { render, staticRenderFns }